import { HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, Injectable, NgModule, inject } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Translation, TranslocoLoader, TranslocoModule, provideTransloco } from '@jsverse/transloco';
import { RootComponent } from 'src/app/components/root/root.component';
import { AppTemplateModule } from 'src/modules/app-template/app-template.module';
import { Config } from 'src/modules/app-template/models/config.model';
import { MainFrontendConfig } from 'src/modules/app-template/models/main-frontend-config.model';
import { MainAppService } from 'src/modules/app-template/services/main-app.service';






import { EnaioPayrollModule } from 'src/modules/enaio-payroll/enaio-payroll.module';




import { RestEndpoint } from 'src/modules/sm-base/models/rest-endpoint.model';
import { SmBaseModule } from 'src/modules/sm-base/sm-base.module';

import { Utils } from 'src/modules/utils/shared/utils';
import { AppRoutes } from './app.routes';
import { AllCommunityModule, ModuleRegistry, provideGlobalGridOptions } from 'ag-grid-community';
import { AllEnterpriseModule, LicenseManager } from "ag-grid-enterprise";


export function init_app(app: MainAppService) {
    return async () => {
        await app.auth.updateUserDetails();
        app.mainConfig = await RestEndpoint.main().find().run("api/app/mainConfig").get(MainFrontendConfig);   
        app.mainConfig.init(); 

        ModuleRegistry.registerModules([AllCommunityModule]);
        
        if (!Utils.isNoe(Config.get().agGridEnterpriseKey)) {
            ModuleRegistry.registerModules([AllEnterpriseModule]);
            LicenseManager.setLicenseKey(Config.get().agGridEnterpriseKey);
        }
        
        provideGlobalGridOptions({ theme: "legacy"});
    };
}

@Injectable({ providedIn: 'root' })
export class TranslocoAppLoader implements TranslocoLoader {

    async getTranslation(language: string): Promise<Translation> {
        return Utils.fromJson(await RestEndpoint.main().query({ language }).run("api/app/translation").getText());
    }
}

@NgModule({
    imports: [
        HttpClientModule,
        BrowserModule,
        BrowserAnimationsModule,
        AppTemplateModule,
        AppRoutes,
        
        
        
        EnaioPayrollModule,
        
        
        
        
        
        
        
        
        
        
        SmBaseModule/*, TODO Kann wieder aktiviert werden, wenn der Worker dann wirklich implementiert ist
        ServiceWorkerModule.register('ngsw-worker.js', { enabled: Config.get().production })*/
    ],
    exports: [
        TranslocoModule
    ],
    declarations: [
        RootComponent
    ],
    bootstrap: [
        RootComponent
    ],
    providers: [
        { provide: APP_INITIALIZER, useFactory: init_app, deps: [MainAppService], multi: true },
        provideTransloco({
            config: {
                availableLangs: ['de', 'en', 'fr', 'es'],
                defaultLang: 'de',
                reRenderOnLangChange: true,
                prodMode: true,
                missingHandler: {
                    logMissingKey: false
                }
            },
            loader: TranslocoAppLoader
        })
    ]
})
export class AppModule {

    app = inject(MainAppService);

    constructor() {
        this.app.appName = Config.get().pageTitle;
        this.app.pageTitle = this.app.appName;
    }
}
